<template>
  <div id="application">
    <!-- 申請表內容 -->
    <div
      id="Application_text"
      class="container"
    >
      <div class="row white-color word-bold">
        <!-- 標題 -->
        <div class="col-4 frame5" />
        <div class="col-5 frame6">
          多元繳費系統-收費項目申請表
        </div>
        <div class="col-3 frame4" />
        <br>
        <!-- 公開收費項目 -->
        <div class="col-3 frame2 pt-1">
          是否為公開收費項目
        </div>
        <div class="col-3 frame3">
          <div class="form-check form-check-inline ml-2">
            <input
              id="FeeItemType1"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.FeeItemType"
              value="1"
            >
            <v-label
              for="FeeItemType1"
              class="form-check-label"
              lab-text="是"
            />
          </div>
          <div class="form-check form-check-inline mt-1">
            <input
              id="FeeItemType2"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.FeeItemType"
              value="2"
            >
            <v-label
              for="FeeItemType2"
              class="form-check-label"
              lab-text="否"
            />
          </div>
        </div>
        <!-- 申請單位 -->
        <div class="col-2 frame7 pt-1">
          申請單位
        </div>
        <div class="col-4 frame3 pt-1">
          <v-font
            font-css="ml-2"
            :font-text="DeptName"
          />
        </div>
        <!-- 收費項目名稱 -->
        <div class="col-2 frame2 pt-2">
          收費項目名稱
        </div>
        <div class="col-4 frame3">
          <input
            class="form-control"
            type="text"
            v-model="Apply.FeeItemName"
          >
        </div>
        <!-- 收費項目編號 -->
        <div class="col-2 frame7 pt-2">
          收費項目編號
        </div>
        <div class="col-4 frame3">
          <input
            class="form-control"
            type="text"
            v-model="Apply.FeeItemId"
            placeholder="系統自動生成"
            disabled
          >
        </div>
        <!-- 繳款金額 -->
        <div class="col-2 frame2 pt-2">
          繳款金額
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="FeeValueType1"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.FeeValueType"
              value="1"
            >
            <v-label
              for="FeeValueType1"
              class="form-check-label"
              lab-text="固定金額"
            />
            <input
              class="ra-input ml-2 mr-2"
              type="text"
              v-model.number="Apply.FeeItemValue"
              @change="CheckNum"
              style="width: 150px;"
            >
            元
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="FeeValueType2"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.FeeValueType"
              value="2"
            >
            <v-label
              for="FeeValueType2"
              class="form-check-label"
              lab-text="非固定金額(由串接系統產生或上傳繳費資料)"
            />
          </div>
        </div>
        <!-- 申請期限 -->
        <div class="col-2 frame2 pt-2">
          申請期限
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="PayDeadline1"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.PayDeadline"
              value="1"
            >
            <label
              class="form-check-label"
              for="PayDeadline1"
            >
              繳費期限
              起始日
              <a-locale-provider :locale="zhTW">
                <a-date-picker
                  size="large"
                  @change="onChange"
                  :format="dateFormat"
                />
              </a-locale-provider>
              截止日
              <a-locale-provider :locale="zhTW">
                <a-date-picker
                  size="large"
                  @change="onChanges"
                  :format="dateFormat"
                />
              </a-locale-provider>
            </label>
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="PayDeadline2"
              class="form-check-input ml-2 mr-2"
              type="radio"
              v-model.number="Apply.PayDeadline"
              value="2"
            >
            <v-label
              for="PayDeadline2"
              class="form-check-label"
              lab-text="無(長期、持續性收款)"
            />
          </div>
        </div>
        <!-- 申請版面-繳費通路 -->
        <div class="col-2 frame2 pt-2">
          繳費通路(複選)
        </div>
        <div class="col-10 frame8">
          <!-- 申請版面-國內信用卡 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            1.
            <input
              id="ApplyBit0"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit0"
              :true-value="1"
              :false-value="0"
            >
            <v-label
              for="ApplyBit0"
              class="form-check-label"
              lab-text="政府機關繳費平台信用卡(手續費2~35元)"
            />
          </div>
          <!-- 申請版面-國外信用卡 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            2.
            <input
              id="ApplyBit1"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit1"
              :true-value="1"
              :false-value="0"
            >
            <v-label
              for="ApplyBit1"
              class="form-check-label"
              lab-text="可收全部信用卡、國外卡、銀聯卡(手續費2%)"
            />
            <v-font
              font-css="small-color"
              font-text="*洽談中，暫停開放"
            />
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="CardRadio1"
              class="form-check-input"
              type="radio"
              v-model="Card.Radio"
              value="本計畫"
            >
            <v-label
              for="CardRadio1"
              class="form-check-label mr-2"
              lab-text="本計畫"
            />
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Card.Input0"
            >
            <v-label
              class="form-check-label ml-2 mr-2"
              lab-text="費"
            />
            <input
              id="CardRadio2"
              class="form-check-input"
              type="radio"
              v-model="Card.Radio"
              value="本單位"
            >
            <v-label
              for="CardRadio2"
              class="form-check-label mr-2"
              lab-text="本單位"
            />
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Card.Input1"
            >
            <v-label
              class="form-check-label ml-2 mr-2"
              lab-text="費"
            />
          </div>
          <div class="form-check form-check-inline">
            <input
              id="CardRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="Card.Radio"
              value="其他計畫"
            >
            <label
              class="form-check-label mr-2"
              for="CardRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="Card.Input2"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-一卡通 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            3.
            <input
              id="ApplyBit2"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit2"
              :true-value="1"
              :false-value="0"
              checked
            >
            <label
              class="form-check-label"
              for="ApplyBit2"
            >
              一卡通(手續費目前 0 元)，此項目為繳費機功能為「必選項目」
            </label>
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="iPASSRadio1"
              class="form-check-input"
              type="radio"
              v-model="iPASS.Radio"
              value="本計畫"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio1"
            >
              本計畫
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input0"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
            <input
              id="iPASSRadio2"
              class="form-check-input"
              type="radio"
              v-model="iPASS.Radio"
              value="本單位"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio2"
            >
              本單位
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input1"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="iPASSRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="iPASS.Radio"
              value="其他計畫"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input2"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-LINE Pay -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            4.
            <input
              id="ApplyBit3"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit3"
              :true-value="1"
              :false-value="0"
            >
            <label
              class="form-check-label"
              for="ApplyBit3"
            >
              LINE PAY (手續費綁帳戶者1.26%、綁信用卡者1.89%)
            </label>
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="LineRadio1"
              class="form-check-input"
              type="radio"
              v-model="Line.Radio"
              value="本計畫"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio1"
            >
              本計畫
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Line.Input0"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
            <input
              id="LineRadio2"
              class="form-check-input"
              type="radio"
              v-model="Line.Radio"
              value="本單位"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio2"
            >
              本單位
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Line.Input1"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="LineRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="Line.Radio"
              value="其他計畫"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="Line.Input2"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-超商繳費單 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            5.
            <input
              id="ApplyBit4"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit4"
              :true-value="1"
              :false-value="0"
              @click="Checkbit4bit5('bit4')"
            >
            <label
              class="form-check-label"
              for="ApplyBit4"
            >
              四大超商繳費單(含銀行、ATM)
            </label>
            <v-font
              font-css="small-color"
              font-text="(包含臨櫃( 土銀)繳費單、WebATM、實體ATM)"
            />
          </div>
          <!-- 申請版面-WebATM -->
          <div class="form-check form-check-inline ml-2 mt-2 mb-2 dblock">
            6.
            <input
              id="ApplyBit5"
              class="form-check-input"
              type="checkbox"
              v-model="Applyselect.bit5"
              :true-value="1"
              :false-value="0"
              @click="Checkbit4bit5('bit5')"
            >
            <label
              class="form-check-label"
              for="ApplyBit5"
            >
              臨櫃( 土銀)繳費單、WebATM、實體ATM
            </label>
            <v-font
              font-css="small-color"
              font-text="(不含四大超商繳費)"
            />
          </div>
        </div>
        <!-- 申請版面-串接系統 -->
        <div class="col-2 frame2 pt-2">
          是否為串接系統
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="IsIntegrated"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.IsIntegrated"
              value="1"
            >
            <label
              class="form-check-label mr-2"
              for="IsIntegrated"
            >
              是，系統名稱
            </label>
            <select
              class="input-style"
              v-model="Apply.IntegratedSysId"
            >
              <option
                v-for="Sysids in Sysid"
                :key="Sysids.id"
                :value="Sysids.IntegratedSysId"
              >
                {{ Sysids.SysName }}
              </option>
            </select>
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="IsIntegrated2"
              class="form-check-input"
              type="radio"
              v-model.number="Apply.IsIntegrated"
              value="0"
            >
            <label
              class="form-check-label"
              for="IsIntegrated2"
            >
              否
            </label>
          </div>
        </div>
        <!-- 共同版面-核章 -->
        <div class="col-12 frame pt-2 text-size textalign">
          業務單位
        </div>
        <div class="col-6 frame2 pt-2 textalign">
          單位管理人核章
        </div>
        <div class="col-6 frame3 pt-2 textalign">
          單位主管核章
        </div>
        <div class="col-6 frame2">
          <br>
          <br>
          <br>
          <br>
        </div>
        <div class="col-6 frame3" />
        <div class="col-12 frame2 textalign">
          主計室
        </div>
        <div class="col-3 frame2 pt-1 textalign">
          會計資料
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          承辦人核章
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          組長核章
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          主計主任核章
        </div>
        <!--會計資料 -->
        <div class="col-3 frame10">
          <div class="row">
            <label
              class="mt-2 ml-2"
              for="AccountingTitle"
            >
              會計科目：
            </label>
            <input
              id="AccountingTitle"
              class="form-control mr-2 ml-2"
              type="text"
              v-model="Apply.AccountingTitle"
              disabled
            >
            <label
              class="mt-2 ml-2"
              for="ProjectNumber"
            >
              計畫編號：
            </label>
            <input
              id="ProjectNumber"
              class="form-control mr-2 ml-2 mb-2"
              type="text"
              v-model="Apply.ProjectNumber"
              disabled
            >
          </div>
        </div>
        <div class="col-3 frame8" />
        <div class="col-3 frame8" />
        <div class="col-3 frame8" />
        <div class="col-12 frame2 textalign">
          總務處
        </div>
        <div class="col-3 frame2 pt-1 textalign">
          承辦人核章
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          出納組長核章
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          總務長核章
        </div>
        <div class="col-3 frame3 pt-1 textalign">
          校長核章
        </div>
        <div class="col-3 frame2">
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
        <div class="col-3 frame3" />
        <div class="col-3 frame3" />
        <div class="col-3 frame3" />
      </div>
    </div>
    <!-- 功能鈕 -->
    <div class="mt-4 no-print">
      <v-button
        class="mb-2"
        btn-text="確認申請"
        btnType="primary"
        @click.native="PostFeeitemApply"
      />
      <v-button
        class="ml-2 mb-2"
        btn-text="回上一頁"
        btnType="secondary"
        @click.native="GoToPrevious"
      />
      <v-button
        class="ml-2 mb-2"
        btn-text="列印申請表"
        btnType="warning"
        @click.native="print"
      />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import { apiFeeitemApply, apiSysid } from '../../Api/api'
import 'ant-design-vue/lib/date-picker/style/css'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    edit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      FeeitemApply: false,
      Apply: {
        ApplyDeptId: '',
        FeeItemName: '',
        FeeItemId: '',
        FeeItemType: 0,
        FeeValueType: 0,
        FeeItemValue: 0,
        PayDeadline: 0,
        PayDatePeriod: 0,
        PayDateBegin: '',
        PayDateEnd: '',
        PayCategory: '',
        CreditChargeSrc: '',
        MifareChargeSrc: '',
        LINEChargeSrc: '',
        AccountingTitle: '',
        ProjectNumber: '',
        IsIntegrated: '3',
        IntegratedSysId: ''
      },
      Applyselect: {
        bit0: 0,
        bit1: 0,
        bit2: 1,
        bit3: 0,
        bit4: 0,
        bit5: 0,
        bit6: 0,
        bit7: 0
      },
      Card: {
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      iPASS: {
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      Line: {
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      DeptId: [],
      Sysid: [],
      UserData: JSON.parse(sessionStorage.getItem('UserData')),
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      DeptName: ''
    }
  },
  created () {
    const vm = this
    vm.DeptName = vm.UserData.UserManyDep
    vm.FeeitemType()
    vm.PostSysid()
  },
  methods: {
    moment,
    print () { // 列印
      var text = document
      print(text)
    },
    date (data) {
      var date
      if (data !== null) {
        date = data.substr(0, 10)
      }
      return date
    },
    onChange (date, dateString) { // 起
      this.Apply.PayDateBegin = dateString
    },
    onChanges (date, dateString) { // 迄
      this.Apply.PayDateEnd = dateString
    },
    FeeitemType () { // 判斷申請ro變更
      if (this.type === 'apply') {
        this.FeeitemApply = true
      } else {
        this.$router.push({ name: 'Admin_Payment_review' })
      }
    },
    PostSysid () { // 異質系統代碼對照表 P_API002
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.IntegratedSysId = '255'
      NewData.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      // 呼叫API
      apiSysid(NewData).then(
        res => {
          if (res !== undefined) {
            vm.Sysid = res.Data
          }
        }
      )
    },
    PostFeeitemApply () { // 申請 B_API 007
      // 定義資料
      const vm = this
      var ErrorTest = ''
      // 判斷必填欄位
      if (vm.Apply.FeeItemType === 0) {
        ErrorTest = '請選擇公開收費項目。'
      }
      if (vm.Apply.ApplyDeptId === '') {
        vm.Apply.ApplyDeptId = vm.UserData.DeptId
      }
      if (vm.Apply.FeeItemName === '') {
        ErrorTest = '請填寫收費項目名稱。'
      }
      if (vm.Apply.FeeValueType === 0) {
        ErrorTest = '請選擇繳款金額。'
      }
      if (vm.Apply.FeeValueType === 1) {
        if (vm.Apply.FeeItemValue <= 0) {
          ErrorTest = '請填寫固定金額。'
        }
      }
      if (vm.Apply.FeeValueType === 2) {
        vm.Apply.FeeItemValue = 0
      }
      if (vm.Apply.PayDeadline === 0) {
        ErrorTest = '請選擇繳費期限類型。'
      } else {
        if (vm.Apply.PayDeadline === 2) {
          vm.Apply.PayDatePeriod = 0
        }
      }
      if (vm.Applyselect.bit0 === 1) {
        if (vm.Card.Radio === '') {
          ErrorTest = '請選擇繳費通路(2)的次項目。'
        } else if (vm.Card.Radio === '本單位') {
          if (vm.Card.Input1 === '') {
            ErrorTest = '請填寫繳費通路(2)本單位。'
          } else {
            vm.Apply.CreditChargeSrc = vm.Card.Radio + ',' + vm.Card.Input1
          }
        } else if (vm.Card.Radio === '其他計畫') {
          if (vm.Card.Input2 === '') {
            ErrorTest = '請填寫繳費通路(2)其他計畫。'
          } else {
            vm.Apply.CreditChargeSrc = vm.Card.Radio + ',' + vm.Card.Input2
          }
        } else {
          vm.Apply.CreditChargeSrc = vm.Card.Radio
        }
      }
      if (vm.Applyselect.bit1 === 1) {
        if (vm.Card.Radio === '') {
          ErrorTest = '請選擇繳費通路(2)的次項目。'
        } else if (vm.Card.Radio === '本單位') {
          if (vm.Card.Input1 === '') {
            ErrorTest = '請填寫繳費通路(2)本單位。'
          } else {
            vm.Apply.CreditChargeSrc = vm.Card.Radio + ',' + vm.Card.Input1
          }
        } else if (vm.Card.Radio === '其他計畫') {
          if (vm.Card.Input2 === '') {
            ErrorTest = '請填寫繳費通路(2)其他計畫。'
          } else {
            vm.Apply.CreditChargeSrc = vm.Card.Radio + ',' + vm.Card.Input2
          }
        } else {
          vm.Apply.CreditChargeSrc = vm.Card.Radio
        }
      }
      if (vm.Applyselect.bit2 === 1) {
        if (vm.iPASS.Radio === '') {
          ErrorTest = '請選擇繳費通路(3)的次項目。'
        } else if (vm.iPASS.Radio === '本單位') {
          if (vm.iPASS.Input1 === '') {
            ErrorTest = '請填寫繳費通路(3)本單位。'
          } else {
            vm.Apply.MifareChargeSrc = vm.iPASS.Radio + ',' + vm.iPASS.Input1
          }
        } else if (vm.iPASS.Radio === '其他計畫') {
          if (vm.iPASS.Input2 === '') {
            ErrorTest = '請填寫繳費通路(3)其他計畫。'
          } else {
            vm.Apply.MifareChargeSrc = vm.iPASS.Radio + ',' + vm.iPASS.Input2
          }
        } else {
          vm.Apply.MifareChargeSrc = vm.iPASS.Radio
        }
      } else {
        ErrorTest = '繳費通路(3)為必填項目。'
      }
      if (vm.Applyselect.bit3 === 1) {
        if (vm.Line.Radio === '') {
          ErrorTest = '請選擇繳費通路(4)的次項目。'
        } else if (vm.Line.Radio === '本單位') {
          if (vm.Line.Input1 === '') {
            ErrorTest = '請填寫繳費通路(4)本單位。'
          } else {
            vm.Apply.LINEChargeSrc = vm.Line.Radio + ',' + vm.Line.Input1
          }
        } else if (vm.Line.Radio === '其他計畫') {
          if (vm.Line.Input2 === '') {
            ErrorTest = '請填寫繳費通路(4)其他計畫。'
          } else {
            vm.Apply.LINEChargeSrc = vm.Line.Radio + ',' + vm.Line.Input2
          }
        } else {
          vm.Apply.LINEChargeSrc = vm.Line.Radio
        }
      }
      if (vm.Apply.IsIntegrated === 3) {
        ErrorTest = '請選擇是否為串接系統。'
      } else if (vm.Apply.IsIntegrated === 1) {
        if (vm.Apply.IntegratedSysId === '') {
          ErrorTest = '請選擇異質系統。'
        }
      }
      if (ErrorTest !== '') {
        vm.ErrorModal(ErrorTest)
        return false
      }
      const num = vm.Applyselect.bit7 + ',' + vm.Applyselect.bit6 + ',' +
                  vm.Applyselect.bit5 + ',' + vm.Applyselect.bit4 + ',' +
                  vm.Applyselect.bit3 + ',' + vm.Applyselect.bit2 + ',' +
                  vm.Applyselect.bit1 + ',' + vm.Applyselect.bit0
      const PayCategory = num.replace(/,/g, '')
      vm.Apply.PayCategory = parseInt(PayCategory, 2)
      const NewApplyData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), vm.Apply)
      // 呼叫API
      apiFeeitemApply(NewApplyData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '申請成功')
            $('#CheckOk').modal('show')
            vm.$router.push({ name: 'Admin_Payment_review' }) // 導向收費項目審核
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    Checkbit4bit5 (data) { // 繳費單選項擇一
      const vm = this
      if (data === 'bit4') {
        var el = document.getElementById('ApplyBit5')
        el.checked = false
        vm.Applyselect.bit4 = 1
        vm.Applyselect.bit5 = 0
      } else if (data === 'bit5') {
        var els = document.getElementById('ApplyBit4')
        els.checked = false
        vm.Applyselect.bit4 = 0
        vm.Applyselect.bit5 = 1
      }
    },
    CheckNum () { // 金額防呆
      const vm = this
      const Value = vm.Apply.FeeItemValue
      if (typeof (Value) === 'number') {
        if (Value < 0) {
          vm.$bus.$emit('Modals', '金額不得小於0')
          $('#CheckError').modal('show')
          vm.Apply.FeeItemValue = 0
        }
      } else {
        vm.$bus.$emit('Modals', '固定金額請輸入數字')
        $('#CheckError').modal('show')
        vm.Apply.FeeItemValue = 0
      }
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    },
    GoToPrevious () {
      this.$router.push({ name: 'Admin_Payment_review' })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/applicationform.scss';

</style>
